import { cloneDeep } from "lodash";
import objectAssign from "object-assign";

import * as actions from "./../../types/actionTypes";
import {
  addToCart,
  removeItemFromCart,
  updateProductQuantity,
  resetCart,
} from "./../utils/cart";
import initialState from "./../initialState";

import * as cookieStorage from "./../../actions/common/cookieStorage";

const cStorage = cookieStorage.getCookieStorage();

function listingShipmentFields(settings, years) {
  const fields = {};

  if (settings) {
    fields.nextShipment = settings.nextShipmentDisplayTime;
    fields.currentShipment = settings.currentShipmentDisplayTime;
    fields.nextShipmentDeadline = settings.nextShipmentOrderDeadline;
    fields.euContainerMode = settings.euContainerMode || null;
  }

  if (years) {
    fields.getCreationTiresPredictedYearsForPreorder = years.tireYears;
  }

  return fields;
}

const handlers = new Map();

handlers.set(actions.LOAD_TIRE_DIMS_WIDTHS, (state, action) => {
  return objectAssign({}, state, {
    widths: action.widths,
  });
});

handlers.set(actions.MOTO_SELECT_WIDTH_DIM, (state, action) => {
  return objectAssign({}, state, {
    selectedWidth: action.selectedWidth,
  });
});

handlers.set(actions.MOTO_TIRE_DIMS_PROFILES, (state, action) => {
  return objectAssign({}, state, {
    profiles: action.profiles,
  });
});

handlers.set(actions.LOAD_TOP_SELLERS, (state, action) => {
  return objectAssign({}, state, {
    topSellers: action.products,
  });
});

handlers.set(actions.LOAD_LIMITED_TIME_OFFERS, (state, action) => {
  return objectAssign({}, state, {
    limitedTimeOffers: action.limitedTimeOffers || [],
  });
});

handlers.set(actions.LOAD_HOMEPAGE_PROMO, (state, action) => {
  return objectAssign({}, state, {
    homepagePromo: action.homepagePromo,
  });
});

handlers.set(actions.LOAD_POPULAR_SIZES, (state, action) => {
  return objectAssign({}, state, {
    popularSizes: action.metrics,
  });
});

handlers.set(actions.LOAD_POPULAR_TIRE_SETS, (state, action) => {
  return objectAssign({}, state, {
    popularTireSets: action.popularTireSets,
  });
});

handlers.set(actions.ADMIN_STATUS_INFLIGHT, (state) => {
  const admin = objectAssign({}, state.admin, {
    during: true,
  });

  return objectAssign({}, state, {
    admin,
  });
});

handlers.set(actions.ADMIN_LOAD_ORDER_PAYMENT, (state, action) => {
  const orderIndex = state.admin.orders.findIndex(
    (o) => Number(o.orderId) === Number(action.orderId)
  );
  if (orderIndex === -1) return state;
  state.admin.orders[orderIndex].cData = action.cData;

  const admin = objectAssign({}, state.admin, {
    orders: state.admin.orders,
  });

  return objectAssign({}, state, {
    admin,
  });
});

handlers.set(actions.ADMIN_ORDER_UPDATED, (state, action) => {
  const admin = objectAssign({}, state.admin, {
    during: false,
    orders: action.result.orders,
    products: action.result.products,
  });

  return objectAssign({}, state, {
    admin,
  });
});

handlers.set(actions.ADMIN_LOAD_ORDERS, (state, action) => {
  const admin = objectAssign({}, state.admin, {
    orders: action.orders,
    products: action.products,
  });

  return objectAssign({}, state, {
    admin,
  });
});

handlers.set(actions.MOTO_SELECT_PROFILE_DIM, (state, action) => {
  return objectAssign({}, state, {
    selectedProfile: action.selectedProfile,
  });
});

handlers.set(actions.MOTO_TIRE_DIMS_RIMS, (state, action) => {
  return objectAssign({}, state, {
    rims: action.rims,
  });
});

handlers.set(actions.MOTO_SELECT_RIM_DIM, (state, action) => {
  return objectAssign({}, state, {
    selectedRim: action.selectedRim,
  });
});

handlers.set(actions.MOTO_RESET_DIMS, (state) => {
  return objectAssign({}, state, {
    profiles: [],
    rims: [],
    selectedProfile: "",
    selectedRim: "",
  });
});

handlers.set(actions.MOTO_SELECT_REAR_WIDTH_DIM, (state, action) => {
  return objectAssign({}, state, {
    rearSelectedWidth: action.rearSelectedWidth,
  });
});

handlers.set(actions.MOTO_SELECT_REAR_PROFILE_DIM, (state, action) => {
  return objectAssign({}, state, {
    rearSelectedProfile: action.rearSelectedProfile,
  });
});

handlers.set(actions.MOTO_SELECT_REAR_RIM_DIM, (state, action) => {
  return objectAssign({}, state, {
    rearSelectedRim: action.rearSelectedRim,
  });
});

handlers.set(actions.MOTO_REAR_TIRE_DIMS_PROFILES, (state, action) => {
  return objectAssign({}, state, {
    rearProfiles: action.profiles,
  });
});

handlers.set(actions.MOTO_REAR_TIRE_DIMS_RIMS, (state, action) => {
  return objectAssign({}, state, {
    rearRims: action.rims,
  });
});

handlers.set(actions.MOTO_RESET_REAR_DIMS, (state) => {
  return objectAssign({}, state, {
    rearSelectedWidth: "",
    rearSelectedProfile: "",
    rearSelectedRim: "",
    rearProfiles: [],
    rearRims: [],
  });
});

handlers.set(actions.SET_FRONT_TOUCHED, (state, action) => {
  return objectAssign({}, state, {
    frontTouched: action.frontTouched,
  });
});

handlers.set(actions.SET_REAR_TOUCHED, (state, action) => {
  return objectAssign({}, state, {
    rearTouched: action.rearTouched,
  });
});

handlers.set(actions.SET_SEARCH_OPEN, (state, action) => {
  return objectAssign({}, state, {
    setSearchOpen: action.setSearchOpen,
  });
});

handlers.set(actions.LOAD_MOTO_TIRES, (state, action) => {
  return objectAssign({}, state, {
    motoTires: action.motoTires.result,
    motoTiresQueryKey: action.motoTiresQueryKey || null,
    listPending: false,
  }, listingShipmentFields(action.motoTires.settings, action.motoTires.years));
});

handlers.set(actions.LOAD_MOTO_TIRE_PAIRS_PENDING, (state, action) => {
  return objectAssign({}, state, {
    tirePairsPending: true,
    tirePairsRequestedKey: action.tirePairsRequestedKey || null,
  });
});

handlers.set(actions.LOAD_MOTO_TIRE_PAIRS, (state, action) => {
  return objectAssign({}, state, {
    motoTirePairs: action.motoTirePairs || [],
    tirePairsQueryKey: action.tirePairsQueryKey || null,
    tirePairsPending: false,
  }, listingShipmentFields(action.settings, action.years));
});

handlers.set(actions.BEST_OFFER_SENT, (state, action) => {
  let bestOfferEANs = [].concat(state.bestOfferEANs);
  bestOfferEANs.push(action.data.ean);

  return objectAssign({}, state, {
    bestOfferEANs,
  });
});

handlers.set(actions.LOADING, (state, action) => {
  return objectAssign({}, state, {
    listPending: action.loading,
  });
});

handlers.set(actions.LOAD_MOTO_TIRES_BY_CAT, (state, action) => {
  return objectAssign({}, state, {
    motoTires: action.motoTires,
    motoTiresQueryKey: action.motoTiresQueryKey || null,
    nextShipment: action.nextShipment,
    euContainerMode: action.euContainerMode || null,
    category: action.category,
    listPending: false,
  });
});

handlers.set(actions.LOAD_PRODUCT_INFLIGHT, (state) => {
  return objectAssign({}, state, {
    product: null,
    productPending: true,
  });
});

handlers.set(actions.LOAD_PRODUCT, (state, action) => {
  return objectAssign({}, state, {
    product: action.product,
    nextShipment: action.nextShipment,
    currentShipment: action.currentShipment,
    nextShipmentDeadline: action.nextShipmentDeadline,
    euContainerMode: action.euContainerMode || null,
    productNotFound: action.productNotFound,
    localStockBlock: action.localStockBlock || null,
    getCreationTiresPredictedYearsForPreorder: action.tireYears,
    productPending: false,
    listPending: false,
  });
});

handlers.set(actions.UPDATE_FILTERS, (state, { filters }) => {
  return objectAssign({}, state, { filters });
});

handlers.set(actions.ADD_PRODUCT_TO_CART, (state, action) => {
  const cart = addToCart(action.ean, action.isSet, action.isAtvSet);

  return objectAssign({}, state, {
    cart,
  });
});

handlers.set(actions.TOGGLE_SNACKBAR, (state, action) => {
  return objectAssign({}, state, {
    toggleSnackbar: action.toggle,
    snackbar: action.snack,
  });
});

handlers.set(actions.CART_PRODUCTS_DATA, (state, action) => {
  // Inspect state to find out if we have a dirty state from the last thank you page
  let resetThankyou = {};

  if (state.thankyou === true) {
    resetThankyou = {
      thankyou: false,
      orderId: undefined,
    };
  }

  return objectAssign(
    {},
    state,
    {
      cartProducts: action.results,
      nextShipment: action.nextShipment,
      currentShipment: action.currentShipmentDisplayTime,
      nextShipmentDeadline: action.nextShipmentOrderDeadline,
      euContainerMode: action.euContainerMode || null,
      localStockBlocks: action.localStockBlocks || [],
    },
    resetThankyou
  );
});

handlers.set(actions.PAYMENT_PAGE_STAGE, (state, action) => {
  if (action.stageName === "/paymentSuccess" && action.orderId) {
    // Reset the cart
    resetCart();

    return objectAssign({}, state, {
      paymentStage: action.stageName,
      orderId: action.orderId,
    });
  }

  return objectAssign({}, state, {
    paymentStage: action.stageName,
  });
});

handlers.set(actions.REMOVE_PRODUCT_FROM_CART, (state, action) => {
  const cart = removeItemFromCart(action.ean);

  const newState = objectAssign({}, state, {
    cart,
  });

  const indexToRemove = newState.cartProducts.findIndex(
    (o) => o.ean === action.ean
  );
  if (indexToRemove !== -1) {
    newState.cartProducts.splice(indexToRemove, 1);
  }

  return newState;
});

handlers.set(actions.CHANGE_PRODUCT_QUANTITY_IN_CART, (state, action) => {
  const cart = updateProductQuantity(action.ean, action.quantity);

  return objectAssign({}, state, {
    cart,
  });
});

handlers.set(actions.CHANGE_SIP, (state, action) => {
  const checkout = objectAssign({}, state.checkout, {
    sip: action.sip,
  });

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.LOAD_INSTALL_CITIES, (state, action) => {
  const checkout = objectAssign({}, state.checkout, {
    cities: action.cities,
  });

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.LOAD_CITIES_FOR_SHOPS_PAGE, (state, action) => {
  const shopIndex = objectAssign({}, state.shopIndex, {
    cities: action.cities,
  });

  return objectAssign({}, state, {
    shopIndex,
  });
});

handlers.set(actions.LOAD_SHOPS_INDEX_PAGE, (state, action) => {
  const shopIndex = objectAssign({}, state.shopIndex, {
    shops: action.shops,
  });

  return objectAssign({}, state, {
    shopIndex,
  });
});

handlers.set(actions.LOAD_SHOP_BY_NAME, (state, action) => {
  const shopIndex = objectAssign({}, state.shopIndex, {
    shop: action.shop,
  });

  return objectAssign({}, state, {
    shopIndex,
  });
});

handlers.set(actions.PICK_CITY_SHOPS_PAGE, (state, action) => {
  const shopIndex = objectAssign({}, state.shopIndex, {
    selectedCity: action.city,
  });

  return objectAssign({}, state, {
    shopIndex,
  });
});

handlers.set(actions.CHANGE_INSTALL_CITY, (state, action) => {
  const checkout = objectAssign({}, state.checkout, {
    selectedCityId: action.city,
  });

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.LOAD_SHOPS, (state, action) => {
  const checkout = objectAssign({}, state.checkout, {
    shops: action.shops,
  });

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.CHANGE_INSTALL_SHOP, (state, action) => {
  const checkout = objectAssign({}, state.checkout, {
    selectedShop: action.shopId,
    dates: [],
  });

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.CLEAR_PICK_SHOP, (state) => {
  const checkout = objectAssign({}, state.checkout, {
    selectedShop: "",
    dates: [],
    slots: [],
    installDate: "",
    installSlot: "",
  });

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.LOAD_OPENDATES_FOR_INSTALLATION, (state, action) => {
  const checkout = objectAssign({}, state.checkout, {
    dates: action.dates,
  });

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.CHANGE_PAYMENT_METHOD, (state, action) => {
  const checkout = objectAssign({}, state.checkout, {
    selectedPaymentMethod: action.method,
  });

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.LOAD_INSTALL_SLOTS, (state, action) => {
  const checkout = objectAssign({}, state.checkout, {
    slots: action.slots,
  });

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.PICK_INSTALL_DATE, (state, action) => {
  const checkout = objectAssign({}, state.checkout, {
    installDate: action.date,
    slots: [],
    installSlot: "",
  });

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.COMPLETE_ORDER, (state, action) => {
  // Reset the cart
  resetCart();

  // Clear saved checkout data from localStorage after successful order
  const { clearCheckoutData } = require('./../utils/checkout');
  clearCheckoutData();

  // Persist on-demand order reference for the customer pending-orders page
  if (action.result.customerAccessToken && action.result.onDemandOrderId != null) {
    try {
      const LS_KEY = "sportyshop_pending_on_demand_orders";
      const existing = JSON.parse(localStorage.getItem(LS_KEY) || "[]");
      const entry = {
        orderId: String(action.result.onDemandOrderId),
        customerAccessToken: action.result.customerAccessToken,
        orderDateKey: action.result.orderDateKey,
        createdAt: new Date().toISOString(),
        status: "received",
      };
      const updated = [entry, ...existing.filter((e) => e.orderId !== entry.orderId)];
      localStorage.setItem(LS_KEY, JSON.stringify(updated));
    } catch (_) {
      // localStorage may be unavailable in some environments
    }
  }

  return objectAssign({}, state, {
    cart: {
      items: [],
    },
    checkout: initialState.catalog.checkout,
    thankyou: true,
    orderId: action.result.orderId.toString(),
  });
});

handlers.set(actions.CHECKOUT_RESET_CART_CONDITIONS, (state) => {
  return objectAssign({}, state, {
    cart: {
      items: [],
    },
    checkout: initialState.catalog.checkout,
    thankyou: false,
  });
});

handlers.set(actions.CHECKOUT_ACTIVE_STEP, (state, action) => {
  const checkout = objectAssign({}, state.checkout, {
    activeStep: action.stepIndex,
  });

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.CHECKOUT_ORDER_ERROR, (state, action) => {
  const checkout = objectAssign({}, state.checkout, {
    activeStep: 1,
    loading: false,
    checkoutError: true,
    checkoutErrorMessage: action.result.message,
    localStockReplacement: action.result.replacement || null,
  });

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.PICK_INSTALL_SLOT, (state, action) => {
  const checkout = objectAssign({}, state.checkout, {
    installSlot: action.slot,
  });

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.LOADER_IS_LOADING, (state, { value }) => {
  const checkout = objectAssign({}, state.checkout, {
    loading: value,
  });

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.FORM_FIELD_CHANGE_PAYMENT, (state, { name, value }) => {
  const modifier = {};
  modifier[name] = value;

  const payment = objectAssign({}, state.checkout.payment, modifier);

  const checkout = objectAssign({}, state.checkout, {
    payment,
  });

  return objectAssign({}, state, {
    checkout,
  });
});

//New handler for additional comments
handlers.set(actions.CHANGE_ADDITIONAL_NOTES, (state, { value }) => {
  const checkout = objectAssign({}, state.checkout, {
    additionalNotes: value,
  });

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.FORM_FIELD_CHANGE_PERSONAL, (state, { name, value }) => {
  const modifier = {};
  modifier[name] = value;

  const personal = objectAssign({}, state.checkout.personal, modifier);

  const checkout = objectAssign({}, state.checkout, {
    personal,
  });

  // Save personal data to localStorage for future use
  const { saveCheckoutPersonalData } = require('./../utils/checkout');
  saveCheckoutPersonalData(personal);

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.FORM_FIELD_CHANGE_SHIPPING, (state, { name, value }) => {
  const modifier = {};
  modifier[name] = value;

  const shipping = objectAssign({}, state.checkout.shipping, modifier);

  const checkout = objectAssign({}, state.checkout, {
    shipping,
  });

  // Save shipping data to localStorage for future use
  const { saveCheckoutShippingData } = require('./../utils/checkout');
  saveCheckoutShippingData(shipping);

  return objectAssign({}, state, {
    checkout,
  });
});

handlers.set(actions.PRODUCT_LIKE, (state, { productId }) => {
  const pIndex = state.stats.data.likes.products.findIndex(
    (p) => p.productId === productId
  );

  const newState = cloneDeep(state);

  let product;

  if (newState.product !== null && newState.product._id === productId) {
    product = newState.product;
  }

  if (!product && newState.motoTires.length > 0) {
    product = newState.motoTires.find((p) => p._id === productId);
  }

  if (pIndex === -1) {
    // Toggle add like
    newState.stats.data.likes.products.push({ productId });
    product.likes += 1;
  } else {
    // Toggle remove like
    newState.stats.data.likes.products.splice(pIndex, 1);
    product.likes += 1;
  }

  cStorage.setObject("stats", newState.stats);

  return newState;
});

handlers.set(actions.SHOP_LIKE, (state, { shopId }) => {
  const pIndex = state.stats.data.likes.shops.findIndex(
    (p) => p.shopId === shopId
  );

  const newState = cloneDeep(state);

  const shops =
    newState.checkout.shops.length > 0
      ? newState.checkout.shops
      : newState.shopIndex.shops;

  const shop = shops.find((p) => p._id === shopId) || newState.shopIndex.shop;

  if (pIndex === -1) {
    // Toggle add like
    newState.stats.data.likes.shops.push({ shopId });
    shop.likes += 1;
  } else {
    // Toggle remove like
    newState.stats.data.likes.shops.splice(pIndex, 1);
    shop.likes -= 1;
  }

  cStorage.setObject("stats", newState.stats);

  return newState;
});

handlers.set(actions.STATS_UPDATED, (state, { stats }) => {
  return objectAssign({}, state, { stats });
});

handlers.set(actions.WIZARD_USER_ANSWER, (state, { payload }) => {
  const wizardPage = objectAssign({}, state.wizardPage, payload);

  return objectAssign({}, state, {
    wizardPage,
  });
});

handlers.set(actions.SET_WIZARD_LOADING, (state) => {
  const wizardPage = objectAssign({}, state.wizardPage, {
    loadingAnswers: true,
    showLayout: true,
  });

  return objectAssign({}, state, {
    wizardPage,
  });
});

handlers.set(actions.RESET_WIZARD, (state) => {
  const wizardPage = objectAssign({}, state.wizardPage, {
    motorcycle: "",
    usage: "בחר את השימוש שלך",
    kilometers: "קילומטרים ממוצעים",
    motorcycleBrand: "בחר את מותג האופנוע שלך",
    motorcycleYear: "בחר את שנת האופנוע שלך",
    selectedTyreType: "בחר קדמי, אחורי או סט",
    visitorName: "",
    visitorPhoneNumber: "",
    showSuggestedTires: false,
    showLayout: false,
    currentWizardStep: 0,
    noTiresFound: false,
    gptResponseError: false,
    limitWizardReached: false,
    tiresSuggestedByGPT: null,
    loadingAnswers: false,
  });

  return objectAssign({}, state, {
    wizardPage,
  });
});

handlers.set(actions.SET_WIZARD_STEP, (state, action) => {
  const wizardPage = objectAssign({}, state.wizardPage, {
    currentWizardStep: action.step,
  });

  return objectAssign({}, state, {
    wizardPage,
  });
});

handlers.set(actions.SUBMIT_WIZARD_ANSWERS, (state, action) => {
  const {
    ok,
    tiresSuggestedInfo,
    noTiresFound,
    gptResponseError,
    limitReached,
    usageId,
  } = action.payload;

  const shouldStopLoading =
    ok || noTiresFound || gptResponseError || limitReached;

  const wizardPage = objectAssign({}, state.wizardPage, {
    tiresSuggestedByGPT: tiresSuggestedInfo || null,
    loadingAnswers: shouldStopLoading ? false : state.wizardPage.loadingAnswers,
    showSuggestedTires: ok ? true : false,
    noTiresFound: noTiresFound || false,
    gptResponseError: gptResponseError || false,
    limitWizardReached: limitReached || false,
    usageId: usageId || null,
  });

  return objectAssign({}, state, {
    wizardPage,
  });
});

handlers.set(actions.TAKE_ALL_MOTO_BRANDS_AVAILABLE, (state, action) => {
  const wizardPage = objectAssign({}, state.wizardPage, {
    allMotoBrandsAvailable: action.brands,
  });

  return objectAssign({}, state, {
    wizardPage,
  });
});

handlers.set(actions.TAKE_MOTO_LIST_FOR_GPT, (state, action) => {
  const wizardPage = objectAssign({}, state.wizardPage, {
    motoListForGPT: action.motorcycles,
    userHasSubmittedModel: false,
  });

  return objectAssign({}, state, {
    wizardPage,
  });
});

handlers.set(actions.SUBMIT_USER_BIKE_MODEL_TO_ADD, (state, action) => {
  const wizardPage = objectAssign({}, state.wizardPage, {
    userModelToAddSubmitted: action.payload.ok,
  });

  return objectAssign({}, state, {
    wizardPage,
  });
});

handlers.set(actions.SET_USER_MODEL_LOADING, (state, action) => {
  const wizardPage = objectAssign({}, state.wizardPage, {
    userModelLoading: action.isLoading,
  });

  return objectAssign({}, state, {
    wizardPage,
  });
});

handlers.set(actions.SHOW_USER_MODEL_SUCCESS, (state, action) => {
  const wizardPage = objectAssign({}, state.wizardPage, {
    showUserModelSuccess: !action.hide,
  });

  return objectAssign({}, state, {
    wizardPage,
  });
});

handlers.set(actions.SET_USER_HAS_SUBMITTED_MODEL, (state, action) => {
  const wizardPage = objectAssign({}, state.wizardPage, {
    userHasSubmittedModel: action.hasSubmitted,
  });

  return objectAssign({}, state, {
    wizardPage,
  });
});

handlers.set(actions.APPLY_COUPON, (state, { code, discount }) => {
  const checkout = objectAssign({}, state.checkout, {
    couponCode: code,
    appliedDiscount: discount,
    checkoutError: false,
  });
  return objectAssign({}, state, { checkout });
});

handlers.set(actions.APPLY_COUPON_ERROR, (state, { error }) => {
  const checkout = objectAssign({}, state.checkout, {
    checkoutError: true,
    checkoutErrorMessage: error,
  });
  return objectAssign({}, state, { checkout });
});

handlers.set(actions.VALIDATE_TIRE_AVAILABILITY_PENDING, (state) => {
  return objectAssign({}, state, {
    tireValidationPending: true,
    tireValidationError: null,
    tireCount: null,
    hasAvailableTires: null,
  });
});

handlers.set(actions.VALIDATE_TIRE_AVAILABILITY_SUCCESS, (state, { tireCount, hasAvailableTires }) => {
  return objectAssign({}, state, {
    tireValidationPending: false,
    tireValidationError: null,
    tireCount,
    hasAvailableTires,
  });
});

handlers.set(actions.VALIDATE_TIRE_AVAILABILITY_ERROR, (state, { error }) => {
  return objectAssign({}, state, {
    tireValidationPending: false,
    tireValidationError: error,
    tireCount: 0,
    hasAvailableTires: false,
  });
});

handlers.set(actions.RESET_TIRE_VALIDATION, (state) => {
  return objectAssign({}, state, {
    tireValidationPending: false,
    tireValidationError: null,
    tireCount: null,
    hasAvailableTires: null,
  });
});

// Draft Orders Handlers
handlers.set("GET_DRAFT_ORDERS_PENDING", (state, action) => ({
  ...state,
  admin: {
    ...state.admin,
    draftOrdersPending: true,
    draftOrdersError: null,
  },
}));

handlers.set("GET_DRAFT_ORDERS_SUCCESS", (state, action) => ({
  ...state,
  admin: {
    ...state.admin,
    draftOrders: action.payload,
    draftOrdersPending: false,
    draftOrdersError: null,
  },
}));

handlers.set("GET_DRAFT_ORDERS_ERROR", (state, action) => ({
  ...state,
  admin: {
    ...state.admin,
    draftOrdersPending: false,
    draftOrdersError: action.payload,
  },
}));

handlers.set("CREATE_DRAFT_ORDER_PENDING", (state, action) => ({
  ...state,
  admin: {
    ...state.admin,
    createDraftOrderPending: true,
    createDraftOrderError: null,
  },
}));

handlers.set("CREATE_DRAFT_ORDER_SUCCESS", (state, action) => ({
  ...state,
  admin: {
    ...state.admin,
    createDraftOrderPending: false,
    createDraftOrderError: null,
  },
}));

handlers.set("CREATE_DRAFT_ORDER_ERROR", (state, action) => ({
  ...state,
  admin: {
    ...state.admin,
    createDraftOrderPending: false,
    createDraftOrderError: action.payload,
  },
}));

handlers.set("GET_DRAFT_ORDER_DETAILS_PENDING", (state, action) => ({
  ...state,
  admin: {
    ...state.admin,
    selectedDraftOrder: null,
  },
}));

handlers.set("GET_DRAFT_ORDER_DETAILS_SUCCESS", (state, action) => ({
  ...state,
  admin: {
    ...state.admin,
    selectedDraftOrder: action.payload,
  },
}));

handlers.set("GET_DRAFT_ORDER_DETAILS_ERROR", (state, action) => ({
  ...state,
  admin: {
    ...state.admin,
    selectedDraftOrder: null,
  },
}));

export default handlers;
